export var NotificationType;
(function (NotificationType) {
    NotificationType["ERROR"] = "error";
    NotificationType["WARNING"] = "warning";
    NotificationType["SUCCESS"] = "success";
    NotificationType["INFO"] = "info";
    NotificationType["ERROR_LIGHT"] = "errorLight";
    NotificationType["WARNING_LIGHT"] = "warningLight";
    NotificationType["INFO_LIGHT"] = "infoLight";
    NotificationType["SUCCESS_LIGHT"] = "successLight";
})(NotificationType || (NotificationType = {}));
//# sourceMappingURL=Notification.types.js.map